module.exports = __webpack_public_path__ + "static/media/payout-option_visa.d614a014.png";